// @flow

type State = {|
  isLoading: boolean,
  advertisementTemplates: Array<{| id: number, name: string, list: Array<string> |}>,
  advertisementTemplateIds: Array<number>,
  advertisementTemplateIdsErrors: Array<string>,
  audiences: Array<{| id: number, name: string, list: Array<string> |}>
|}

type PatchAction = {|
  +type: 'AT_ASSIGN.PATCH',
  +state: $Shape<State>
|}

type PutAction = {|
  +type: 'AT_ASSIGN.PUT',
  +state: State
|}

type Action = PatchAction | PutAction

export type { State }

const initialState: State = {
  isLoading: false,
  advertisementTemplates: [],
  advertisementTemplateIds: [],
  advertisementTemplateIdsErrors: [],
  audiences: []
}

export function put(state: State): PutAction {
  return {
    type: 'AT_ASSIGN.PUT',
    state: state
  }
}

export function patch(diff: $Shape<State>): PatchAction {
  return {
    type: 'AT_ASSIGN.PATCH',
    state: diff
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'AT_ASSIGN.PUT':
      return action.state
    case 'AT_ASSIGN.PATCH':
      return { ...state, ...action.state }
    default:
      return state
  }
}
